import { Label } from "@/components/ui/label";
import { TFunction } from "i18next";
import { JSX } from "react";

/**
 * Displays the visit amounts for a specific day.
 *
 * @param {Object} props - The component props.
 * @param {string} props.day - The day of the visit.
 * @param {number} props.dayValue - The amount for the day visit.
 * @param {number} props.nightValue - The amount for the night visit.
 * @returns {JSX.Element} - The JSX element displaying the visit amounts.
 */
export const VisitAmountsDisplay = ({
  t,
  day,
  dayValue,
  nightValue,
}: {
  t: TFunction;
  day: string;
  dayValue: number;
  nightValue: number;
}): JSX.Element => {
  return (
    <div className="flex items-center gap-2 text-sm">
      <Label className="w-2/6 min-w-[80px] font-semibold">
        {t(`common:weekdaysfull.${day.toLowerCase()}`)}
      </Label>
      <div className="grid-2 w-4/6 gap-2 text-center">
        <span>{dayValue}</span>
        <span>{nightValue}</span>
      </div>
    </div>
  );
};
